


































































































































































































































/* tslint:disable */
import { SwExtendedVue } from "@sonicwall/unified-ui-framework/src/shared/sw-extended-vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import uuifComponent from "@/shared/uuifComponent";
import { MswAppTitle } from "@/shared/msw-app-title";
import Showquotedetails from "./showquotedetail.vue";
import { PageTitleConfig } from "../../../../shared/msw-app-title/type";
import { SetHelpContentIdPayload } from "@/core";
import { Mutation } from "vuex-class";
import { VuexMappedMutation } from "@sonicwall/unified-ui-framework/src/shared/common-types";
const cssPrefix = "snb-quote-details-component";

@Component({
  components: {
    ...uuifComponent,
    MswAppTitle,
    Showquotedetails,
  },
})
export default class SandboxQuoteDetails extends SwExtendedVue {
  /* tslint:disable */
  cssPrefix = cssPrefix;
  // quoteId: string|(string|null)[];

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  get quoteId() {
    return this.$route.query.selectedQuoteId;
  }

  pageTitleConfig: PageTitleConfig = {
    pageTitle: this.$t('quote.editQuote').toString() || '',
    pageParentName: "",
    tab: "",
    isShowBackButton: true,
    backButtonAction: this.backButtonActions.bind(this),
  };

  backButtonActions() {
    this.$router.push("/m/feature/quotehistory");
    if ((window as { [key: string]: any }).top.location.href !== (window as { [key: string]: any }).location.href) {
      (window as { [key: string]: any }).parent.postMessage(
        {
          redirectUrl : "/m/feature/quotehistory",
        },
        '*',
      );
    }
  }

  mounted() {
    this.setHelpId('quotehistory');
  }

  setHelpId(value:string) {
    const temp:string[] = [];
    temp.push(value);
    this.setHelpContentId({ helpId:temp });
  }

  destroyed() {
    this.setHelpId('default');
  }
}
